import { styled } from '@uhg-abyss/web/tools/styled';

export const ToolTipStyles = styled('div', {
  '.abyss-tooltip-trigger': {
    textAlign: 'left',
  },
  display: 'inline-block',
});
